export const EPOCH_DURATION = {
  HOURS_6: "hours_6",
  HOURS_12: "hours_12",
  HOURS_24: "hours_24",
  HOURS_48: "hours_48",
  DAYS_7: "days_7",
} as const;
export type EPOCH_DURATION = (typeof EPOCH_DURATION)[keyof typeof EPOCH_DURATION];

export const REWARD_RULE = {
  PROPORTIONAL: "proportional",
  FIXED_SPOT: "fixed_spot",
} as const;
export type REWARD_RULE = (typeof REWARD_RULE)[keyof typeof REWARD_RULE];

export const CAMPAIGN_VISIBILITY = {
  PUBLIC: "public",
  PRIVATE: "private",
} as const;
export type CAMPAIGN_VISIBILITY = (typeof CAMPAIGN_VISIBILITY)[keyof typeof CAMPAIGN_VISIBILITY];

export const HOLDING_EPOCH_STATUS = {
  PENDING: "pending",
  ACTIVE: "active",
  COMPLETED: "completed",
} as const;
export type HOLDING_EPOCH_STATUS = (typeof HOLDING_EPOCH_STATUS)[keyof typeof HOLDING_EPOCH_STATUS];

export const REWARD_NETWORK = {
  ETHEREUM: "Ethereum",
  AVALANCHE_C_CHAIN: "Avalanche C-Chain",
  ARBITRUM_ONE: "Arbitrum One",
  POLYGON: "Polygon",
  OPTIMISM: "Optimism",
  BNB_SMART_CHAIN: "BNB Smart Chain",
  SOLANA: "Solana",
  BITCOIN: "Bitcoin",
} as const;
export type REWARD_NETWORK = (typeof REWARD_NETWORK)[keyof typeof REWARD_NETWORK];
